jQuery(function () {
    $(".ChooseSection li button").on('click keypress', function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            event.preventDefault();
            $(".ChooseSection li button").removeClass("focus").removeAttr("aria-live").attr("aria-label", "");
            $(".ChooseSection li button").closest(".focus").removeClass("focus");
            $(this).addClass('focus').attr("aria-live", "assertive").attr("aria-label", "You have selected Radio btn " + $(this).text());
            $(this)[0].focus();
        }
    });

    $(".IconWrapper button").on('click keypress', function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            event.preventDefault();
            $('.IconWrapper button').closest(".ProductFinder-item").find(".focus").removeAttr("aria-live");
            $(this).closest(".ProductFinder-item").find(".focus").removeClass("focus").removeAttr("aria-live").attr("aria-label", "");
            $(this).closest(".ProductFinder-item").find(".focus").attr("aria-label", "Radio btn " + $(this).text())
            $(this).addClass("focus").attr("aria-live", "assertive").attr("aria-label", "You have selected Radio btn " + $(this).text());
            $(this)[0].focus();
            //toggle aria-checked
            $(this).closest(".ProductFinder-item").find('button[role="radio"]')
                .attr("aria-checked", "false");
            $(this).attr("aria-checked", "true");
            $(this).closest('.MandatorySection').addClass('validated');
            ValidateSection();
        }
    });
    $(".SectionFilter").on('click keydown', function (event) {
        if (event.type === "click" || (event.type === "keydown" && event.key === "Enter")) {

            if ($(this).hasClass('disable')) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    });

    $(".BooleanWrapper button").on('click keypress', function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {

            event.preventDefault();
            $(this).closest('.MandatorySection').addClass('validated');
            ValidateSection();
        }
    });


    function ValidateSection() {
        if ($('.MandatorySection').length !== $('.validated').length) {
            $('.SectionFilter').addClass('disable');

        } else {
            $('.SectionFilter').removeClass('disable');
            $('.FilterMessage').hide();
        }
    }

    $('.ProductFinder-chooseYes').click(function (event) {
        event.preventDefault();
        $(this).closest('.ProductFinder-item').find('.ButtonSelection').removeClass("ProductFinder-switchtoNo ProductFinder-notSelected");
        $(this).closest('.ProductFinder-item').find('.ProductFinder-switchtoNo').removeClass("focus");
        $(this).closest('.ProductFinder-item').find('.ButtonSelection').addClass("ProductFinder-switchtoYes");
        $(this).addClass('focus');
    });

    $('.ProductFinder-chooseNo').click(function () {
        event.preventDefault();
        $(this).closest('.ProductFinder-item').find('.ButtonSelection').removeClass("ProductFinder-switchtoYes ProductFinder-notSelected");
        $(this).closest('.ProductFinder-item').find('.ProductFinder-switchtoYes').removeClass("focus");
        $(this).closest('.ProductFinder-item').find('.ButtonSelection').addClass("ProductFinder-switchtoNo");
        $(this).addClass('focus');
    });

    // this function is used for absorbency value in product selector result
    function isInteger(num) {
        return (num ^ 0) === num;
    }

    function GetComplementaryDescription(descriptionText, item) {
        const complementaryWindowWidthOne = 1025;
        const complementarySizeSplitConstOne = 56;
        const complementarySizeSplitConstTwo = 40;
        if ($(window).width() > complementaryWindowWidthOne) {
            if (item.description.length > complementarySizeSplitConstOne) {
                descriptionText = '<p><a href="javascript:void(0);" class="js-toggle-tooltip"' +
                    ' tabindex="-1" data-stick="true" data-description="' +
                    item.description + '">' +
                    item.description.substring(0, complementarySizeSplitConstOne) +
                    '<span class="toggle-tooltip">...</span></a></p>';
            } else {
                descriptionText = '<p>' + item.description + '</p>';
            }
        } else {
            if (item.description.length > complementarySizeSplitConstTwo) {
                descriptionText = '<p><span class="noTooltip-mobile" tabindex="-1"' +
                    ' data-stick="true" data-description="' + item.description + '">' +
                    item.description.substring(0, complementarySizeSplitConstTwo) +
                    '<span class="toggle-tooltip">...</span></span></p>';
            } else {
                descriptionText = '<p>' + item.description + '</p>';
            }
        }
        return descriptionText;
    }

    function GetComplementaryHtml(complementaryProducts, item) {
        complementaryProducts += '<div class="ConsiderProduct-container ListingBlock">';
        complementaryProducts += '<div class="ConsiderProduct-img col-3"><img src="' +
            item.productImageUrl + '" alt="' +
            item.altText + '" title="' + item.altText + '" class="ListingProduct-img"></div>';
        complementaryProducts += '<input type="hidden" class="articleNumber" value="' + item.articleNumber + '">';
        complementaryProducts += '<div class="ConsiderProduct col-9">';
        complementaryProducts += '<h4>' + item.productName + '</h4>';
        return complementaryProducts;
    }

    $(".SectionFilter").on('click keypress', function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            event.preventDefault();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "ga4_product_suggestion_cta",
            });
            $('.loaderWrapper').show();

            var filterData = {};
            var productData = {};

            $(".ProductFinder-item .focus").each(function (i, e) {
                productData = {};
                $.each(e.attributes, function (j, v) {
                    if (/^data/.test(v.nodeName)) {
                        productData[v.nodeName] = v.nodeValue;
                    }
                });
                var id = $(e).closest(".ProductFinder-item").attr("id");
                if (id === "Gender") {
                    productData.isUnisexProductFirst = $(".ProductPriority-hidden").val();
                    productData.enableSampleForSelector = $(".ProductSampleButton-hidden").val();
                }
                filterData[id] = productData;
            });

            var contextPathValue = $('#context-path-value').attr('data-context-path');
            var URL = window.location.origin + contextPathValue + "/api/Services/ProductFinder/GetProductSelectorResult";

            $.ajax({
                type: 'POST',
                url: URL,
                data: {
                    inputData: JSON.stringify(filterData),
                    complimentaryProducts: $('.ComplimentaryProducts-hidden').val()
                },
                dataType: 'json',
                success: function (data) {
                    $('.loaderWrapper').hide();
                    $('.ProductSearch-results').show();
                    $('#RecommendedProductBlock').html('');
                    $('#ConsiderProductsBlock').html('');
                    $('#ComplementaryProductBlock').html('');
                    $('#RecommendedProductBlock').show();
                    $('#ConsiderProductsBlock').show();
                    $('#ComplementaryProductBlock').show();
                    $('#ProductHeader').html('');
                    $('#ProductHeader').show();
                    $("#NoResultFound").hide();
                    var jsondata = data;
                    var descriptionText = '';
                    $('.BigButton').html(jsondata.resultButtonToggleText);
                    if (jsondata.noProductsFoundLabel === "") {
                        $('#ProductHeader').html(jsondata.productResultSectionHeader);
                        var recommendedProducts = "";
                        recommendedProducts += '<h4 class="ProductCards--Title">' + jsondata.recommendedProduct.recommendedSectionLabel +
                            '</h4>';


                        if (window.matchMedia('(min-width: 991px)').matches) {
                            recommendedProducts += '<div class="RecommendedProduct SectionContainer--details " >';
                            recommendedProducts += '<p><img src="' + jsondata.recommendedProduct.recommendedProduct.productImageUrl + '"  alt="' +
                                jsondata.recommendedProduct.recommendedProduct.altText + '" title="' +
                                jsondata.recommendedProduct.recommendedProduct.altText + '"></p>';
                            recommendedProducts += '<input type="hidden" class="articleNumber" value="' +
                                jsondata.recommendedProduct.recommendedProduct.articleNumber + '">';
                        } else {
                            recommendedProducts += '<div class="RecommendedProduct SectionContainer--details row iPadVersion" >';
                            recommendedProducts += '<div class="recommendedProduct-img col-4"><img src="' + jsondata.recommendedProduct.recommendedProduct.productImageUrl + '"  alt="' +
                                jsondata.recommendedProduct.recommendedProduct.altText + '" title="' +
                                jsondata.recommendedProduct.recommendedProduct.altText + '"></div>';
                            recommendedProducts += '<input type="hidden" class="articleNumber" value="' +
                                jsondata.recommendedProduct.recommendedProduct.articleNumber + '">';
                        }
                        window.addEventListener('resize', function () {
                            if (window.matchMedia('(min-width: 991px)').matches) {
                                recommendedProducts += '<div class="RecommendedProduct SectionContainer--details " >';
                                recommendedProducts += '<p><img src="' + jsondata.recommendedProduct.recommendedProduct.productImageUrl + '"  alt="' +
                                    jsondata.recommendedProduct.recommendedProduct.altText + '" title="' +
                                    jsondata.recommendedProduct.recommendedProduct.altText + '"></p>';
                                recommendedProducts += '<input type="hidden" class="articleNumber" value="' +
                                    jsondata.recommendedProduct.recommendedProduct.articleNumber + '">';
                            } else {
                                $('.RecommendedProduct.SectionContainer--details').addClass('iPadVersion row');
                                $('.iPadVersion > p').addClass('recommendedProduct-img col-4');
                                if (!$('.iPadVersion .articleNumber').length) {
                                    $('.iPadVersion').append('<input type="hidden" class="articleNumber" value="' +
                                        jsondata.recommendedProduct.recommendedProduct.articleNumber + '">');
                                }
                            }
                        });
                        const recommnedWindowWidthConst = 1025;
                        const productNameLengthOne = 120;
                        const productNameLengthTwo = 50;
                        var isSizeAvailable = jsondata.recommendedProduct.recommendedProduct.isSizeAvailable;
                        if (isSizeAvailable) {
                            let adjustedHeight = function () {
                                if ($('.ProductSearch-results').css('display') === 'block' && window.matchMedia('(min-width: 991px)').matches) {
                                    // $('.ListingBlock').addClass('adjusted_height');
                                    //  $('.RecommendedProduct.SectionContainer--details').addClass('adjusted_height_firstCard');
                                } else {
                                    //  $('.ListingBlock').addClass('adjusted_height_ipad');
                                    //  $('.RecommendedProduct.SectionContainer--details').addClass(' adjusted_height_ipadfirstCard');
                                }
                            }
                            setTimeout(function () {
                                adjustedHeight();
                            }, 1000);
                            window.addEventListener('resize', function () {
                                adjustedHeight();
                            });
                        }
                        else {
                            $('.adjusted_height').removeClass('adjusted_height');
                            $('.adjusted_height_ipad').removeClass('adjusted_height_ipad');
                            $('.adjusted_height_firstCard').removeClass('adjusted_height_firstCard');
                            $('.adjusted_height_ipadfirstCard').removeClass('adjusted_height_ipadfirstCard');
                        }
                        if ($(window).width() > recommnedWindowWidthConst) {
                            if (jsondata.recommendedProduct.recommendedProduct.productName.length >= productNameLengthOne) {
                                recommendedProducts += '<div class="recommendedProduct col-8"><h4><a href="#" class="js-toggle-tooltip" tabindex="-1" data-stick="true"' +
                                    ' data-description="' + jsondata.recommendedProduct.recommendedProduct.productName + '">' +
                                    jsondata.recommendedProduct.recommendedProduct.productName.substring(0, productNameLengthOne) +
                                    '<span class="toggle-tooltip">...</span></a></h4>';
                            } else {
                                recommendedProducts += '<div class="recommendedProduct col-8"><h4>' + jsondata.recommendedProduct.recommendedProduct.productName + '</h4>';
                            }
                        } else {
                            if (jsondata.recommendedProduct.recommendedProduct.productName.length >= productNameLengthTwo) {
                                recommendedProducts += '<div class="recommendedProduct col-8"><h4><span class="noTooltip-mobile" tabindex="-1" data-stick="true" data-description="' +
                                    jsondata.recommendedProduct.recommendedProduct.productName + '">' +
                                    jsondata.recommendedProduct.recommendedProduct.productName.substring(0, productNameLengthTwo) +
                                    '<span class="toggle-tooltip">...</span></span></h4>';
                            } else {
                                recommendedProducts += '<div class="recommendedProduct col-8"><h4>' + jsondata.recommendedProduct.recommendedProduct.productName + '</h4>';
                            }
                        }
                        if ($(window).width() > recommnedWindowWidthConst) {
                            if (jsondata.recommendedProduct.recommendedText.length >= productNameLengthOne) {
                                descriptionText = '<p><a href="javascript:void(0);" class="js-toggle-tooltip" tabindex="-1" data-stick="true" data-description="' +
                                    jsondata.recommendedProduct.recommendedText + '">' +
                                    jsondata.recommendedProduct.recommendedText.substring(0, productNameLengthOne) +
                                    '<span class="toggle-tooltip">...</span></a></p>';
                            } else {
                                descriptionText = '<p>' + jsondata.recommendedProduct.recommendedText + '</p>';
                            }
                        } else {
                            if (jsondata.recommendedProduct.recommendedText.length >= productNameLengthTwo) {
                                descriptionText = '<p><span class="noTooltip-mobile" tabindex="-1" data-stick="true" data-description="' +
                                    jsondata.recommendedProduct.recommendedText + '">' +
                                    jsondata.recommendedProduct.recommendedText.substring(0, productNameLengthTwo) +
                                    '<span class="toggle-tooltip">...</span></span></p>';
                            } else {
                                descriptionText = '<p>' + jsondata.recommendedProduct.recommendedText + '</p>';
                            }
                        }
                        recommendedProducts += descriptionText;
                        //dot added as per absorbancy unit
                        var recommendedAbsorbencyUnit = jsondata.recommendedProduct.recommendedProduct.absorbencyUnit;
                        var ariaAbsorbencyRangeLabel = jsondata.recommendedProduct.recommendedProduct.ariaAbsorbencyRangeLabel;
                        var ariaAbsorbencyHeading = jsondata.recommendedProduct.recommendedProduct.ariaAbsorbencyHeading;
                        var recommendedAbsorbencyValue = jsondata.recommendedProduct.recommendedProduct.absorbencyValue;
                        var recommendedMaximumAbsorbency = jsondata.recommendedProduct.recommendedProduct.maximumAbsorbency;
                        if (recommendedMaximumAbsorbency == null || recommendedMaximumAbsorbency == 0) {
                            recommendedMaximumAbsorbency = 8;
                        }
                        if (recommendedAbsorbencyUnit === 'dot') {
                            recommendedProducts += '<div class="ProductResults--attributes"><div class="Attribute--detail"><h4>' +
                                jsondata.absorbencyLabel +
                                ' </h4><ul class="Icon--Dots" id="recommended-rating" tabindex="0" aria-label="' +
                                ariaAbsorbencyHeading + ' ' +
                                recommendedAbsorbencyValue + ' ' +
                                ariaAbsorbencyRangeLabel + ' ' +
                                recommendedMaximumAbsorbency +
                                '">';
                        } else {
                            recommendedProducts += '<div class="ProductResults--attributes"><div class="Attribute--detail"><h4>' +
                                jsondata.absorbencyLabel +
                                ' </h4><ul class="iconWrapSection rating" id="recommended-rating" tabindex="0" aria-label="' +
                                ariaAbsorbencyHeading + ' ' +
                                recommendedAbsorbencyValue + ' ' +
                                ariaAbsorbencyRangeLabel + ' ' +
                                recommendedMaximumAbsorbency +
                                '">';
                        }

                        if (isInteger(recommendedAbsorbencyValue)) {
                            var totalParts1 = recommendedAbsorbencyValue.toString();
                            var totalHalf1 = 0;
                        } else {
                            var totalParts1 = recommendedAbsorbencyValue.toString().split(".");
                            var totalHalf1 = totalParts1.length > 0 ? totalParts1[1].length : 0;
                        }
                        var totalInteger1 = parseInt(totalParts1[0], 10);
                        var temp1 = "";
                        if (recommendedAbsorbencyUnit === 'dot') {
                            const dotTotalCount = 4;
                            for (var j = 0; j < totalInteger1; j++) {
                                temp1 += '<li><span class="dotStyle icon-dots-full"></span></li>';
                            }
                            for (var j = 0; j < totalHalf1; j++) {
                                temp1 += '<li><span class="dotStyle icon-dots-half"></span></li>';
                            }
                            if (recommendedMaximumAbsorbency !== null && recommendedMaximumAbsorbency !== 0) {
                                for (var j = 0; j < recommendedMaximumAbsorbency - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                }
                            } else if (recommendedMaximumAbsorbency === 0) {
                                for (var j = 0; j < dotTotalCount - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                }
                            } else {
                                for (var j = 0; j < dotTotalCount - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                }
                            }
                        } else {
                            const dropTotalCount = 8;
                            for (var j = 0; j < totalInteger1; j++) {
                                temp1 += '<li><i class="dropfilledWrapper dropfilled"></i></li>';
                            }
                            for (var j = 0; j < totalHalf1; j++) {
                                temp1 += '<li><i class="dropfilledWrapper dropHalf"></i></li>';
                            }
                            if (recommendedMaximumAbsorbency !== null && recommendedMaximumAbsorbency !== 0) {
                                for (var j = 0; j < recommendedMaximumAbsorbency - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                }
                            } else if (recommendedMaximumAbsorbency === 0) {
                                for (var j = 0; j < dropTotalCount - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                }
                            } else {
                                for (var j = 0; j < dropTotalCount - (totalHalf1 + totalInteger1); j++) {
                                    temp1 += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                }
                            }
                        }

                        $("#recommended-rating").html(temp1);
                        recommendedProducts += temp1;
                        recommendedProducts += '</ul></div>';
                        var recommendedSizesAvailable = jsondata.recommendedProduct.recommendedProduct.sizesAvailable;
                        var recommendedSizeSplit = recommendedSizesAvailable.split(" ").length;
                        const sizeConstOne = 2;
                        const sizeConstTwo = 5;
                        const sizeConstThree = 6;
                        const recommendWidthConst = 1025;
                        var isSizeAvailable = jsondata.recommendedProduct.recommendedProduct.isSizeAvailable;
                        if (isSizeAvailable) {
                            let adjustedHeight = function () {
                                if ($('.ProductSearch-results').css('display') === 'block' && window.matchMedia('(min-width: 991px)').matches) {
                                    // $('.ListingBlock').addClass('adjusted_height');
                                    //   $('.RecommendedProduct.SectionContainer--details').addClass('adjusted_height_firstCard');
                                } else {
                                    // $('.ListingBlock').addClass('adjusted_height_ipad');
                                    $('.RecommendedProduct.SectionContainer--details').addClass(' adjusted_height_ipadfirstCard');
                                }
                            }
                            setTimeout(function () {
                                adjustedHeight();
                            }, 1000);
                            window.addEventListener('resize', function () {
                                adjustedHeight();
                            });
                        }
                        else {
                            $('.adjusted_height').removeClass('adjusted_height');
                            $('.adjusted_height_ipad').removeClass('adjusted_height_ipad');
                            $('.adjusted_height_firstCard').removeClass('adjusted_height_firstCard');
                            $('.adjusted_height_ipadfirstCard').removeClass('adjusted_height_ipadfirstCard');
                        }
                        if ($(window).width() > recommendWidthConst) {
                            if (recommendedSizeSplit >= sizeConstOne && recommendedSizeSplit <= sizeConstTwo) {
                                recommendedProducts += '<div class="Attribute--detail Sizes--available"><h4>' + jsondata.sizesAvailableLabel +
                                    '</h4>';
                                recommendedProducts += '<span>' + recommendedSizesAvailable + '</span></div>';

                            } else if (recommendedSizeSplit >= sizeConstThree) {
                                recommendedProducts += '<div class="Attribute--detail Sizes--available"><h4>' + jsondata.sizesAvailableLabel +
                                    '</h4>';
                                recommendedProducts += '<span><a href="javascript:void(0);" class="js-toggle-tooltip" tabindex="-2" data-stick="true"' +
                                    ' data-description="' + recommendedSizesAvailable + '">' +
                                    recommendedSizesAvailable.split(/\s+/).slice(0, sizeConstTwo).join(" ") +
                                    '<span class="toggle-tooltip">...</span></a></span></div>';
                            }
                        } else {
                            if (recommendedSizeSplit >= sizeConstOne && recommendedSizeSplit <= sizeConstTwo) {
                                recommendedProducts += '<div class="Attribute--detail Sizes--available"><h4>' + jsondata.sizesAvailableLabel +
                                    '</h4>';
                                recommendedProducts += '<span>' + recommendedSizesAvailable + '</span></div>';
                            } else if (recommendedSizeSplit >= sizeConstThree) {
                                recommendedProducts += '<div class="Attribute--detail Sizes--available"><h4>' + jsondata.sizesAvailableLabel +
                                    '</h4>';
                                recommendedProducts += '<span class="noTooltip-mobile" tabindex="-2" data-stick="true" data-description="' +
                                    recommendedSizesAvailable + '">' +
                                    recommendedSizesAvailable.split(/\s+/).slice(0, sizeConstTwo).join(" ") +
                                    '<span class="toggle-tooltip">...</span></span>' +
                                    '</div>';
                            }
                        }

                        recommendedProducts += '</div>';


                        if (window.matchMedia('(min-width: 991px)').matches) {
                            if (jsondata.recommendedProduct.isSampleEnableInCms === true) {
                                if (jsondata.recommendedProduct.sampleOrderButtonText !== "") {
                                    recommendedProducts += '<a href="' + jsondata.recommendedProduct.sampleOrderRedirectUrl +
                                        '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                        jsondata.recommendedProduct.sampleOrderButtonText + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                }
                                recommendedProducts += '<a href = "' + jsondata.recommendedProduct.recommendedProduct.productPageUrl +
                                    '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                    jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                            } else {
                                recommendedProducts += '<a href = "' + jsondata.recommendedProduct.recommendedProduct.productPageUrl +
                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                    jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                            }
                        } else {
                            if (jsondata.recommendedProduct.isSampleEnableInCms === true) {
                                if (jsondata.recommendedProduct.sampleOrderButtonText !== "") {
                                    recommendedProducts += '</div><div class="ProductResult--ProductCardCTA"><a href="' + jsondata.recommendedProduct.sampleOrderRedirectUrl +
                                        '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                        jsondata.recommendedProduct.sampleOrderButtonText + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a></div>';
                                }
                                recommendedProducts += '</div><div class="ProductResult--ProductCardCTA"><a href = "' + jsondata.recommendedProduct.recommendedProduct.productPageUrl +
                                    '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                    jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a></div>';
                            } else {
                                recommendedProducts += '</div><div class="ProductResult--ProductCardCTA"><a href = "' + jsondata.recommendedProduct.recommendedProduct.productPageUrl +
                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                    jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a></div>';
                            }
                        }
                        recommendedProducts += '</div>';

                        $('#RecommendedProductBlock').append(recommendedProducts);
                        /* $(".js-toggle-tooltip").tooltip();*/
                        if (typeof jsondata.considerationProducts !== "undefined") {
                            if (typeof jsondata.considerationProducts.products !== "undefined" &&
                                jsondata.considerationProducts.products.length !== 0) {
                                var considerationProducts = '<h4 class="ProductCards--Title">' +
                                    jsondata.considerationProducts.considerSectionLabel + '</h4>';
                                var consierProductsArray = jsondata.considerationProducts.products;
                                $.each(consierProductsArray, function (id, item) {

                                    var isSizeAvailable = item.isSizeAvailable;
                                    if (isSizeAvailable) {
                                        let adjustedHeight = function () {
                                            if ($('.ProductSearch-results').css('display') === 'block' && window.matchMedia('(min-width: 991px)').matches) {
                                                $('.ListingBlock').addClass('adjusted_height');
                                                $('.RecommendedProduct.SectionContainer--details').addClass('adjusted_height_firstCard');
                                            } else {
                                                $('.ListingBlock').addClass('adjusted_height_ipad');
                                                //  $('.RecommendedProduct.SectionContainer--details').addClass(' adjusted_height_ipadfirstCard');
                                            }
                                        }
                                        setTimeout(function () {
                                            adjustedHeight();
                                        }, 1000);
                                        window.addEventListener('resize', function () {
                                            adjustedHeight();
                                        });
                                    }
                                    else {
                                        $('.adjusted_height').removeClass('adjusted_height');
                                        $('.adjusted_height_ipad').removeClass('adjusted_height_ipad');
                                        $('.adjusted_height_firstCard').removeClass('adjusted_height_firstCard');
                                        $('.adjusted_height_ipadfirstCard').removeClass('adjusted_height_ipadfirstCard');
                                    }

                                    considerationProducts += '<div class="ConsiderProduct-container ListingBlock">';
                                    considerationProducts += '<div class="ConsiderProduct-img col-3"><img src="' + item.productImageUrl +
                                        '" alt="' + item.altText + '" title="' + item.altText + '" class="ListingProduct-img"></div>';
                                    considerationProducts += '<input type="hidden" class="articleNumber" value="' + item.articleNumber + '">';
                                    considerationProducts += '<div class="ConsiderProduct col-9">';
                                    const windowWidthConstant = 1228;
                                    const considerationProductLengthOne = 55;
                                    const considerationProductLengthTwo = 32;
                                    const considerationProductLengthThree = 56;
                                    const considerationProductLengthFour = 40;
                                    if ($(window).width() > windowWidthConstant) {
                                        if (item.productName.length >= considerationProductLengthOne) {
                                            var productNameText = '<h4><a href="javascript:void(0);" class="js-toggle-tooltip"' +
                                                ' tabindex="-2" data-stick="true" data-description="' + item.productName + '">' +
                                                item.productName.substring(0, considerationProductLengthOne) +
                                                '<span class="toggle-tooltip">...</span></a></h4>';
                                        } else {
                                            var productNameText = '<h4>' + item.productName + '</h4>';
                                        }
                                    } else {
                                        if (item.productName.length >= considerationProductLengthTwo) {
                                            var productNameText = '<h4><span class="noTooltip-mobile"' +
                                                ' tabindex="-2" data-stick="true" data-description="' + item.productName + '">' +
                                                item.productName.substring(0, considerationProductLengthTwo) +
                                                '<span class="toggle-tooltip">...</span></span></h4>';
                                        } else {
                                            var productNameText = '<h4>' + item.productName + '</h4>';
                                        }
                                    }
                                    considerationProducts += productNameText;
                                    if ($(window).width() > windowWidthConstant) {
                                        if (item.description.length >= considerationProductLengthThree) {
                                            descriptionText = '<p><a href="javascript:void(0)" class="js-toggle-tooltip" ' +
                                                ' tabindex="-1" data-stick="true" data-description="' +
                                                item.description + '">' + item.description.substring(0, considerationProductLengthThree) +
                                                '<span class="toggle-tooltip">...</span></a></p>';
                                        } else {
                                            descriptionText = '<p>' + item.description + '</p>';
                                        }
                                    } else {
                                        if (item.description.length >= considerationProductLengthFour) {
                                            descriptionText = '<p><span class="noTooltip-mobile"' +
                                                ' tabindex="-1" data-stick="true" data-description="' +
                                                item.description + '">' +
                                                item.description.substring(0, considerationProductLengthFour) +
                                                '<span class="toggle-tooltip">...</span></span></p>';
                                        } else {
                                            descriptionText = '<p>' + item.description + '</p>';
                                        }
                                    }
                                    var considerationAbsorbencyUnit = item.absorbencyUnit;
                                    var ariaAbsorbencyRangeLabel = item.ariaAbsorbencyRangeLabel;
                                    var ariaAbsorbencyHeading = item.ariaAbsorbencyHeading;
                                    var considerationAbsorbencyValue = item.absorbencyValue;
                                    var considerationMaximumAbsorbency = item.maximumAbsorbency;
                                    if (considerationMaximumAbsorbency == null || considerationMaximumAbsorbency == 0) {
                                        considerationMaximumAbsorbency = 8;
                                    }
                                    considerationProducts += descriptionText;
                                    if (considerationAbsorbencyUnit === 'dot') {
                                        considerationProducts += '<div class="ProductResults--attributes"><div class="Attribute--detail"><h4>' +
                                            jsondata.absorbencyLabel + '</h4><ul class="Icon--Dots" id="consider-rating" tabindex="0" aria-label="' +
                                            ariaAbsorbencyHeading + ' ' +
                                            considerationAbsorbencyValue + ' ' +
                                            ariaAbsorbencyRangeLabel + ' ' +
                                            considerationMaximumAbsorbency +
                                            '">';
                                    } else {
                                        considerationProducts += '<div class="ProductResults--attributes"><div class="Attribute--detail"><h4>' +
                                            jsondata.absorbencyLabel + '</h4><ul class="iconWrapSection rating" id="consider-rating" tabindex="0" aria-label="' +
                                            ariaAbsorbencyHeading + ' ' +
                                            considerationAbsorbencyValue + ' ' +
                                            ariaAbsorbencyRangeLabel + ' ' +
                                            considerationMaximumAbsorbency +
                                            '">';
                                    }


                                    if (isInteger(considerationAbsorbencyValue)) {
                                        var totalParts = considerationAbsorbencyValue.toString();
                                        var totalHalf = 0;
                                    } else {
                                        var totalParts = considerationAbsorbencyValue.toString().split(".");
                                        var totalHalf = totalParts.length > 0 ? totalParts[1].length : 0;
                                    }
                                    var totalInteger = parseInt(totalParts[0], 10);
                                    var temp = "";
                                    const considerDotCount = 4;
                                    const considerDropCount = 8;
                                    if (considerationAbsorbencyUnit === 'dot') {
                                        for (var k = 0; k < totalInteger; k++) {
                                            temp += '<li><span class="dotStyle icon-dots-full"></span></li>';
                                        }
                                        for (var k = 0; k < totalHalf; k++) {
                                            temp += '<li><span class="dotStyle icon-dots-half"></span></li>';
                                        }
                                        if (considerationMaximumAbsorbency !== null && considerationMaximumAbsorbency !== 0) {
                                            for (var k = 0; k < considerationMaximumAbsorbency - (totalHalf + totalInteger); k++) {
                                                temp += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                            }
                                        } else if (considerationMaximumAbsorbency === 0) {
                                            for (var k = 0; k < considerDotCount - (totalHalf + totalInteger); k++) {
                                                temp += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                            }
                                        } else {
                                            for (var k = 0; k < considerDropCount - (totalHalf + totalInteger); k++) {
                                                temp += '<li><span class="dotStyle icon-dots-empty"></span></li>';
                                            }
                                        }
                                    } else {
                                        for (var k = 0; k < totalInteger; k++) {
                                            temp += '<li><i class="dropfilledWrapper dropfilled"></i></li>';
                                        }
                                        for (var k = 0; k < totalHalf; k++) {
                                            temp += '<li><i class="dropfilledWrapper dropHalf"></i></li>';
                                        }
                                        if (considerationMaximumAbsorbency !== null && considerationMaximumAbsorbency !== 0) {
                                            for (var k = 0; k < considerationMaximumAbsorbency - (totalHalf + totalInteger); k++) {
                                                temp += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                            }
                                        } else if (considerationMaximumAbsorbency === 0) {
                                            for (var k = 0; k < considerDropCount - (totalHalf + totalInteger); k++) {
                                                temp += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                            }
                                        } else {
                                            for (var k = 0; k < considerDropCount - (totalHalf + totalInteger); k++) {
                                                temp += '<li><i class="dropfilledWrapper dropEmpty"></i></li>';
                                            }
                                        }
                                    }

                                    $("#consider-rating").html(temp);

                                    considerationProducts += temp;
                                    considerationProducts += '</ul></div>';
                                    var considerSizesAvailable = item.sizesAvailable;
                                    var considerSizeSplit = considerSizesAvailable.split(" ").length;
                                    const considerWindowWidthOne = 1025;
                                    const considerSizeSplitConstOne = 2;
                                    const considerSizeSplitConstTwo = 5;
                                    const considerSizeSplitConstThree = 6;

                                    if ($(window).width() > considerWindowWidthOne) {
                                        if (considerSizeSplit >= considerSizeSplitConstOne && considerSizeSplit <= considerSizeSplitConstTwo) {
                                            considerationProducts += '<div class="Attribute--detail Sizes--available"><h4>' +
                                                jsondata.sizesAvailableLabel + '</h4>';
                                            considerationProducts += '<span>' + considerSizesAvailable + '</span></div>';
                                        } else if (considerSizeSplit >= considerSizeSplitConstThree) {
                                            considerationProducts += '<div class="Attribute--detail Sizes--available"><h4>' +
                                                jsondata.sizesAvailableLabel + '</h4>';
                                            considerationProducts += '<span><a href="javascript:void(0)" class="js-toggle-tooltip" tabindex="-2"' +
                                                ' data-stick="true" data-description="' + considerSizesAvailable + '">' +
                                                considerSizesAvailable.split(/\s+/).slice(0, considerSizeSplitConstTwo).join(" ") +
                                                '<span class="toggle-tooltip">...</span></a></span></div>';
                                        }
                                    } else {
                                        if (considerSizeSplit >= considerSizeSplitConstOne && considerSizeSplit <= considerSizeSplitConstTwo) {
                                            considerationProducts += '<div class="Attribute--detail Sizes--available"><h4>' +
                                                jsondata.sizesAvailableLabel + '</h4>';
                                            considerationProducts += '<span>' + considerSizesAvailable + '</span></div>';
                                        } else if (considerSizeSplit >= considerSizeSplitConstThree) {
                                            considerationProducts += '<div class="Attribute--detail Sizes--available"><h4>' +
                                                jsondata.sizesAvailableLabel + '</h4>';
                                            considerationProducts += '<span class="noTooltip-mobile" tabindex="-2" data-stick="true"' +
                                                ' data-description="' + considerSizesAvailable + '">' +
                                                considerSizesAvailable.split(/\s+/).slice(0, considerSizeSplitConstTwo).join(" ") +
                                                '<span class="toggle-tooltip">...</span></span></div>';
                                        }
                                    }
                                    const considerWindowWidthTwo = 567;
                                    if ($(window).width() > considerWindowWidthTwo) {
                                        considerationProducts += '</div></div><div class="ProductResult--ProductCardCTA">';
                                        if (item.isSampleEnableInCms === true) {
                                            if (item.sampleOrderButtonText !== "") {
                                                considerationProducts += '<a href="' + item.sampleOrderRedirectUrl +
                                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                    item.sampleOrderButtonText + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                            }
                                            considerationProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        } else {
                                            considerationProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        }
                                        considerationProducts += '</div></div>';
                                    } else {
                                        considerationProducts += '</div><div class="ProductResult--ProductCardCTA">';
                                        if (item.isSampleEnableInCms === true) {
                                            if (item.sampleOrderButtonText !== "") {
                                                considerationProducts += '<a href="' + item.sampleOrderRedirectUrl +
                                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                    item.sampleOrderButtonText + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                            }
                                            considerationProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        } else {
                                            considerationProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        }
                                        considerationProducts += '</div></div></div>';
                                    }
                                });
                                $('#ConsiderProductsBlock').append(considerationProducts);
                                /* $(".js-toggle-tooltip").tooltip();*/
                            } else
                                $('#ConsiderProductsBlock').hide();
                        } else
                            $('#ConsiderProductsBlock').hide();
                        if (typeof jsondata.complimentaryProducts !== "undefined") {
                            if (typeof jsondata.complimentaryProducts.products !== "undefined" &&
                                jsondata.complimentaryProducts.products.length !== 0) {
                                var complementaryProducts = '<h4 class="ProductCards--Title">' +
                                    jsondata.complimentaryProducts.complimentaryProductSectionLabel + '</h4>';
                                var complementaryProductsArray = jsondata.complimentaryProducts.products;
                                $.each(complementaryProductsArray, function (id, item) {
                                    complementaryProducts = GetComplementaryHtml(complementaryProducts, item);
                                    descriptionText = GetComplementaryDescription(descriptionText, item);
                                    complementaryProducts += descriptionText;
                                    const complementaryWindowWidthTwo = 567;
                                    if ($(window).width() > complementaryWindowWidthTwo) {
                                        complementaryProducts += '</div><div class="ProductResult--ProductCardCTA">';
                                        if (item.isSampleEnableInCms === true) {
                                            if (item.sampleOrderButtonText !== "") {
                                                complementaryProducts += '<a href="' + item.sampleOrderRedirectUrl +
                                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                    item.sampleOrderButtonText + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                            }
                                            complementaryProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        } else {
                                            complementaryProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        }
                                        complementaryProducts += '</div></div>';
                                    } else {
                                        complementaryProducts += '<div class="ProductResult--ProductCardCTA">';
                                        if (item.isSampleEnableInCms === true) {
                                            if (item.sampleOrderButtonText !== "") {
                                                complementaryProducts += '<a href="' + item.sampleOrderRedirectUrl +
                                                    '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' + item.sampleOrderButtonText +
                                                    '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                            }
                                            complementaryProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary secondaryCTA" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        } else {
                                            complementaryProducts += '<a href="' + item.productPageUrl +
                                                '" class="CTA-right-arrow CTA_button CTA_button_primary" target="new"><span>' +
                                                jsondata.findOutMoreLabel + '</span><svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 0.141113L21.7071 6.84822L15 13.5553L14.2929 12.8482L19.792 7.34811L0.5 7.34822V6.34822L19.793 6.34811L14.2929 0.84822L15 0.141113Z" fill="white"/></svg></a>';
                                        }

                                        complementaryProducts += '</div></div></div>';
                                    }
                                });
                                $('#ComplementaryProductBlock').append(complementaryProducts);
                            } else $('#ComplementaryProductBlock').hide();
                        } else $('#ComplementaryProductBlock').hide();

                        $(".ProductListing-container h4.ProductCards--Title").each(
                            function () {
                                const $h4 = $(this);
                                // Create a new h2 element with all attributes and content preserved
                                const $h2 = $("<h2/>")
                                    .addClass($h4.attr("class"))
                                    .html($h4.html());
                                $h4.replaceWith($h2);
                            }
                        );
                        $(
                            " .ProductListing-container .ConsiderProduct.col-9 > h4 ,.ProductListing-container .recommendedProduct.col-8 > h4 "
                        ).each(function () {
                            const $h4 = $(this);
                            const $h3 = $("<h3/>")
                                .addClass($h4.attr("class"))
                                .html($h4.html());
                            $h4.replaceWith($h3);
                        });
                        const bigButtonDelayDuration = 1000;
                        $('html, body').delay(bigButtonDelayDuration).animate({
                            scrollTop: ($('.BigButton-Container').offset().top)
                        });

                        /*$(".js-toggle-tooltip").tooltip();*/
                    } else {
                        $('#ProductHeader').hide();
                        $('#RecommendedProductBlock').hide();
                        $('#ConsiderProductsBlock').hide();
                        $('#ComplementaryProductBlock').hide();
                        $("#NoResultFound").html(jsondata.noProductsFoundLabel);
                        $("#NoResultFound").show();
                    }
                },
                error: function () {
                    //var err = eval("(" + xhr.responseText + ")");
                }
            });
        }
    });

    $(".Button--resetSelection").on('click keypress', function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            event.preventDefault();
            $(".ChooseSection li button").removeClass("focus");
            $(".ProductFinder-item").find(".focus").removeClass("focus");
            $('.BooleanWrapper button').removeClass("focus");
            $('.ChooseTitle button').removeClass("focus");
            $('.ButtonWrapper .ButtonSelection').removeClass("ProductFinder-switchtoYes ProductFinder-switchtoNo");
            $('.ButtonWrapper .ButtonSelection').addClass("ProductFinder-notSelected");
            $('.SectionFilter').addClass('disable');
            $('.MandatorySection').removeClass('validated');
            $('.ProductSearch-results').hide();
            $('html, body').delay(1000).animate({
                scrollTop: ($('.PageTitle').offset().top)
            });
            $('.FilterMessage').show();
        }
    });


    const articleTextLength = 21;
    $('.ArticleProgress-backgroundColor').each(function () {
        if ($(this).text().length > articleTextLength) {
            $(this).text($(this).text().substring(0, articleTextLength));
        }
    });

    const messageDelayDuartion = 1000;
    const messageOffsetTop = 130;
    $('#btnOrderSample').click(function () {
        if ($('.validate-message').is(':visible')) {
            $('html, body').delay(messageDelayDuartion).animate({
                scrollTop: ($('.Form--MainWrapper').find('.validate-message:visible:first').offset().top - messageOffsetTop)
            });
        }
    });
    $(document).ready(function () {
        $(document).on("click", ".RecommendedProduct a.CTA_button, .ConsiderProduct-container a.CTA_button", function (event) {
            event.preventDefault();
            var parentContainer = $(this).closest(".RecommendedProduct, .ConsiderProduct-container");
            var productName = parentContainer.find("h4").first().text().trim();
            var productGpimID = parentContainer.find(".articleNumber").val();
            var productUrl = $(this).attr("href");
            var goToProductTextElement = $(this).find('span');
            var goToProductText = goToProductTextElement.length > 0 ? goToProductTextElement.text() : '';
            var protocol = window.location.protocol;
            var hostname = window.location.hostname;
            var externalUrl = /^(?:(https?|ftp):\/\/|www\.)/;

            if (!externalUrl.test(productUrl)) {
                productUrl = protocol + "//" + hostname + productUrl;
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "ga4_product_click",
                "ga4_data": {
                    "single_item_id": productGpimID || "Unknown ID",
                    "single_item_name": productName || "Unknown Product",
                    "link_text": goToProductText,
                    "link_url": productUrl || "Unknown URL"
                }
            });
            if (productUrl) {
                window.location = productUrl;
            }
            return false;
        });
    });

jQuery(function ($) {
    if (window.matchMedia('(max-width: 576px)').matches) {
        $('.validationBtnSec').parents('.section').children('.container').css('padding', '0');
    }
});

//height adjusted for the product selector urine items not looking good when three rows are added 
jQuery(function () {
    const iconTitles = document.querySelectorAll(".urineVolume--Wrapper .IconTitle");

    if (iconTitles.length === 0) return;

    let maxHeight = 0;

    // Step 1: Find the max height
    iconTitles.forEach(el => {
        el.style.height = "auto"; // reset any previously set height
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
    });

    // Step 2: Apply max height to all
    iconTitles.forEach(el => {
        el.style.height = maxHeight + "px";
    });
});

});
